// extracted by mini-css-extract-plugin
export default {"root":"trade-bar-time-left_root__t6VPK"};